import ReportGenerator from "./ReportGenerator"
export default ReportGenerator